import { Box, Text } from "@chakra-ui/react";

const Hero = ({ selectedTab, setSelectedTab }) => {
  const handleTabSelect = (index) => {
    setSelectedTab(index);
  };

  return (
    <Box bgColor="blue.color" px="5%">
      <Box
        color="white"
        pt="70px"
        pb={selectedTab === 5 ? "80px" : "150px"}
        display={{ base: "block", xxmd: "flex" }}
        flexDirection={{ base: "column", xxmd: "row" }}
        alignItems={{ base: "align-start", xxmd: "center" }}
        justifyContent="space-between"
      >
        <Box mb={{ base: "60px" }}>
          <Text
            fontFamily="semibold"
            mb={{ base: "10px", md: "0" }}
            fontSize={35}
          >
            Welcome Back, Precious
          </Text>
          <Text fontFamily="light" fontSize={14}>
            This is your Monthly Overview Report
          </Text>
        </Box>
        <Box
          borderBottom="2px"
          borderColor="#3c649f"
          display="flex"
          fontSize={14}
          justifyContent={{ base: "space-between", xxmd: "start" }}
          fontFamily="regular"
          gap={{ base: 0, xxmd: 10 }}
        >
          <Text
            onClick={() => handleTabSelect(0)}
            cursor="pointer"
            borderBottom={selectedTab === 0 ? "2px" : "none"}
            color={selectedTab === 0 ? "gold.color" : "white"}
            borderColor={selectedTab === 0 ? "gold.color" : "white"}
            pb="10px"
          >
            Overview
          </Text>
          <Text
            onClick={() => handleTabSelect(1)}
            borderBottom={selectedTab === 1 ? "2px" : "none"}
            cursor="pointer"
            pb="10px"
            color={selectedTab === 1 ? "gold.color" : "white"}
            borderColor={selectedTab === 1 ? "gold.color" : "white"}
          >
            Wallet
          </Text>
          <Text
            onClick={() => handleTabSelect(2)}
            borderBottom={selectedTab === 2 ? "2px" : "none"}
            cursor="pointer"
            pb="10px"
            color={selectedTab === 2 ? "gold.color" : "white"}
            borderColor={selectedTab === 2 ? "gold.color" : "white"}
          >
            Invoice
          </Text>
          <Text
            onClick={() => handleTabSelect(3)}
            borderBottom={selectedTab === 3 ? "2px" : "none"}
            cursor="pointer"
            pb="10px"
            color={selectedTab === 3 ? "gold.color" : "white"}
            borderColor={selectedTab === 3 ? "gold.color" : "white"}
          >
            Payment
          </Text>
          <Text
            onClick={() => handleTabSelect(4)}
            borderBottom={selectedTab === 4 ? "2px" : "none"}
            cursor="pointer"
            pb="10px"
            color={selectedTab === 4 ? "gold.color" : "white"}
            borderColor={selectedTab === 4 ? "gold.color" : "white"}
          >
            Profile
          </Text>

          <Text
            display={{ base: "none", sm: "block" }}
            onClick={() => handleTabSelect(5)}
            borderBottom={selectedTab === 5 ? "2px" : "none"}
            cursor="pointer"
            pb="10px"
            color={selectedTab === 5 ? "gold.color" : "white"}
            borderColor={selectedTab === 5 ? "gold.color" : "white"}
          >
            Help
          </Text>
          <Text
            display={{ base: "none", sm: "block" }}
            onClick={() => handleTabSelect(6)}
            borderBottom={selectedTab === 6 ? "2px" : "none"}
            cursor="pointer"
            pb="10px"
            color={selectedTab === 6 ? "gold.color" : "white"}
            borderColor={selectedTab === 6 ? "gold.color" : "white"}
          >
            Report
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
